import React from "react";
import PropTypes from "prop-types";
import SendButton from "../../shared/SendButton/SendButton";
import ChatFormInput from "../../shared/ChatFormInput/ChatFormInput";
import ContainerReponse from "../../Layout/ContainerReponse/ContainerReponse";
//================ STEP 3 ===============

const HandlePhone = ({
                         messageValue,
                         addMessage,
                         addBotMessage,
                         inputDisabled,
                         setInputDisable,
                         setUserInfos,
                         loadingBotMessage,
                         responseBotDelay,
                         setStep,
                         updatePhoneNumber,
                         handleChange
                     }) => {
    const handleTelSubmit = (e) => {
        loadingBotMessage(true);
        e.preventDefault();
        // const phoneNumberRegex = /^0[1-6789]([-. ]?\d{2}){4}$/;
        // if (!phoneNumberRegex.test(messageValue)) {
        //     if (messageValue === "") {
        //         e.preventDefault();
        //     } else {
        //         addMessage(messageValue);
        //         setInputDisable(true);
        //         ***Regex*** : accepte seulement les formats à 10 chiffres commençant par 0 + les points, espaces et tirets. Exemple : 0678987898 ou 04.12.34.12.32 ou 07 98 78 45 65
        //         Cf. https://openclassrooms.com/fr/courses/918836-concevez-votre-site-web-avec-php-et-mysql/917386-les-expressions-regulieres-partie-2-2#r-2178263
        // setTimeout(() => {
        //     loadingBotMessage(false);
        //     addBotMessage("Le numéro que vous envoyez ne semble pas être au bon format. Veuillez utlisez un format à 10 chiffres comme celui-ci : xxxxxxxxxx ou xx.xx.xx.xx.xx ou xx xx xx xx xx", "bot");
        //     setInputDisable(false);
        // }, responseBotDelay);
        // }
        // } else {
        if (messageValue === "") {
            e.preventDefault();
        } else {
            loadingBotMessage(true);
            addMessage(messageValue);
            setUserInfos(messageValue, "tel");
            setInputDisable(true);
            // Regex qui accepte seulement les formats à 10 chiffres. Exemple : 0678987898
            setTimeout(() => {
                loadingBotMessage(false);
                addBotMessage("Bien reçu. Afin de mieux préparer notre rendez-vous, pouvez-vous décrire en quelques lignes votre situation et/ou celle de votre proche ? ", "bot");
                setInputDisable(false);
                updatePhoneNumber();
                setStep(4);
            }, responseBotDelay);
        }
        // }
    };
    return (
        <ContainerReponse>
            <ChatFormInput
                onSubmit={handleTelSubmit}
                toggleFocusOn={inputDisabled}
                type="text"
                label="Envoyez votre numéro de téléphone"
                value={messageValue}
                onChange={handleChange}
                valueToActive={messageValue}
                disabled={inputDisabled ? "disabled" : ""}
                required={true}
            >
                <SendButton disabled={inputDisabled || !messageValue ? "disabled" : ""}/>
            </ChatFormInput>
        </ContainerReponse>
    );
};

HandlePhone.propTypes = {
    responseBotDelay: PropTypes.number,
    setStep: PropTypes.func,
    handleChange: PropTypes.func,
    setMessageValue: PropTypes.func,
    messageValue: PropTypes.string,
    inputDisabled: PropTypes.bool,
    addMessage: PropTypes.func,
    addBotMessage: PropTypes.func,
    setInputDisable: PropTypes.func,
    setUserInfos: PropTypes.func,
    loadingBotMessage: PropTypes.func,
    updatePhoneNumber: PropTypes.func,
};

export default HandlePhone;
